<template>
    <div class="code mdl-list__item mdl-grid cursor-hand"  v-on:click="orderFood()"
         v-bind:class="{'mdl-color--green-600': isFoodSelected(), 'ordered': isFoodSelected()}"
         :style="disabled ? 'pointer-events: none;' : ''"><!---->

        <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone">
            {{ food.foodCode }}
          <img src="/medal_gold.png" width="32" v-if="gold">
          <img src="/medal_silver.png" width="32" v-if="silver">
          <img src="/medal_bronze.png" width="32" v-if="bronze">
        </div>

        <span class="mdl-cell mdl-cell--4-col-phone"
              v-bind:class="{'mdl-cell--10-col-desktop': food.foodOptions.length > 0, 'mdl-cell--8-col-desktop' : food.foodOptions.length <= 0,
                             'mdl-cell--6-col-tablet': food.foodOptions.length > 0, 'mdl-cell--8-col-tablet' : food.foodOptions.length <= 0}">
            {{ food.name }}
        </span>

        <span class="name mdl-cell mdl-cell--2-offset-desktop"
              v-bind:class="{'mdl-cell--8-col-desktop': food.foodOptions.length > 0, 'mdl-cell--hide-desktop' : food.foodOptions.length <= 0,
                              'mdl-cell--8-col-tablet': food.foodOptions.length > 0, 'mdl-cell--hide-tablet' : food.foodOptions.length <= 0}">
            <div v-for="option in food.foodOptions"
                 v-bind:key="option.foodOptionId" type="button" class="option mdl-chip cursor-hand mdl-shadow--2dp"
                 v-bind:class="{'mdl-color--accent': isOptionSelected(option.foodOptionId), 'ordered': isOptionSelected(option.foodOptionId)}"
                 v-on:click="orderFoodWithOption(food.foodId, option.foodOptionId, $event)">
                 
                 <!--{{ selectedOptions }} {{ order }}
                {{ isOptionSelected(option.foodOptionId) }}-->
                <span class="mdl-chip__text">{{ option.foodOptionType.name }}</span>
            </div>
        </span>

        <div class="mdl-cell mdl-cell--hide-desktop mdl-cell--2-col-tablet mdl-cell--2-col-phone">
            {{ food.foodCode }}
          <img src="/medal_gold.png" width="32" v-if="gold">
          <img src="/medal_silver.png" width="32" v-if="silver">
          <img src="/medal_bronze.png" width="32" v-if="bronze">
        </div>

        <span class="price mdl-list__item-text-body mdl-cell mdl-cell--2-col mdl-cell--1-col-tablet mdl-cell--1-col-phone mdl-cell--1-offset-phone mdl-cell--4-offset-tablet"
              :class="{'ordered': isFoodSelected()}">
            {{ food.price }}Kč
        </span>

        <hr class="separator mdl-cell mdl-cell--12-col mdl-cell--hide-desktop mdl-cell--hide-tablet"/>
    </div>
</template>

<script>
    /* eslint-disable no-unused-vars */
    import axios from "axios"
    import config from "../config"

    export default {
        name: "FoodItem",
        props: {
            order: Object,
            selectedOptions: Array,
            selectedSoup: Number,
            food: Object,
            forUser: String,
            day: String,
            gold: Boolean,
            silver: Boolean,
            bronze: Boolean,
            disabled: Boolean
        },
        data: function() {
            return {
                snackbarCounter: 0,
                message: ""
            }
        },
        methods: {
            orderFood: function (optionId = -1) {
                if (this.isFoodSelected()) {
                    axios
                        .delete(config.host + "/v1/order/food/" + this.forUser + "/" + this.day)
                        .then(response => {
                            this.$emit('ordered-food');
                            this.$emit('snack', "Objednávka hlavního jídla zrušena...");
                        })
                        .catch(reason => {
                            this.$emit('snack', "Objednávku nelze zrušit...");
                        });
                } else {
                    axios
                        .post(config.host + "/v1/order/food", { forUser: this.forUser, foodId: this.food.foodId, optionIds: [optionId] })
                        .then(response => {
                            this.$emit('ordered-food');
                            this.$emit('snack', "Hlavní jídlo úspěšně objednáno...");
                        })
                        .catch(reason => {
                            this.$emit('snack', "Hlavní jídlo nelze objednat...");
                        });
                }
            },
            orderFoodWithOption: function (foodId, optionId, event) {
                if (this.isOptionSelected(optionId)) //just toggle order (delete in this case)
                    this.orderFood();
                else if(this.order !== null && this.order.orderedFood.foodId === foodId) //just add option
                    this.selectOption(this.order.foodOrderId, optionId);
                else  //order and select option
                    this.orderFood(optionId);

                event.stopPropagation();
            },
            selectOption: function(orderId, optionId) {
                axios.post(
                    config.host + "/v1/order/food/" + orderId + "/option/" + optionId)
                    .then(res => {
                        this.$emit('ordered-food');
                        this.$emit('snack', "Příloha úspěšně objednána...");
                    })
            },
            isOptionSelected: function (optionId) {
                if (this.selectedOptions === null)
                    return false;
                let found = false;
                this.selectedOptions.forEach(option => {
                    if (option.foodOptionId === optionId)
                        found = true;
                });
                return found;
            },
            isFoodSelected: function () {
                if (this.order == null || this.order.orderedFood == null)
                    return false;
                return this.food.foodId === this.order.orderedFood.foodId;
            }
        }
    }
</script>

<style scoped>
    .separator {
        border: 0.25px solid #DDDDDD;
    }

    .price {
        font-weight: 300;
    }

    .name {
        color: black;
        font-weight: 400;
    }

    .code {
        color: #666666;
        font-weight: 300;
    }

    .code:hover {
        background: #999999;
        color: white;
    }

    .option {
        margin-left: .25rem;
    }

    .cursor-hand {
        cursor: pointer;
    }

    .option:hover {
        background: #666666;
        color: white;
    }

    .ordered {
        color: white;
    }
</style>